import { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";

//Helper functions
import { getSettings } from '../../../settings/Helpers';

//API
import api from '../../../settings/AxiosSetup';

//3rd party
import toast, { Toaster } from 'react-hot-toast';
import { TailSpin } from  'react-loader-spinner';

//Components
import SideNav from '../../../components/sidenav/sidenav';
import BottomNav from '../../../components/bottomnav/bottomnav';
import DashboardHeader from '../../../components/dashboard/header';

//Assets
import svzArtwork from '../../../assets/images/artwork-svz.svg';

//styles
import './visitekaartjes.css';

const Visitekaartjes = () => {

    //Set variables
    const navigate = useNavigate();
    const loggedIn = localStorage.getItem('ingelogd');
    const medewerker = JSON.parse(localStorage.getItem('medewerker'));
    const [isLoading, setIsLoading] = useState(false);

    //Initialize notify for error and success
    const notifyError = (text) => toast.error(text, {
        position: "top-center"
    });
    const notifySuccess = (text) => toast.success(text, {
        position: "top-center"
    });


    //Check if user is authenticated, else redirect to login
    useEffect(() => {
        //Get settings and check for maintenance
        const settings = getSettings();
        settings.then((result) => {
            if (result.onderhoudsmodus) {
                navigate('/onderhoud');
            }
        });
        if (loggedIn !== 'true') {
            navigate('/login');
        }
    }, []);
    
    return (
    <div id="main" className="dashboard">
        {
            medewerker ?
            <SideNav page="/visitekaartjes" />
            :
            null
        }
        
        <div className="dashboard-content">
            <DashboardHeader title="Visitekaartjes" />
            <Toaster />
        </div>
        {
            medewerker ?
            <BottomNav page="/visitekaartjes" />
            :
            null
        }
    <img src={svzArtwork} className="artwork" />    
    </div>
    );
};
export default Visitekaartjes;